import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useEffect } from 'react';
import JsBarcode from 'jsbarcode';
function maskName(name) {
    if (!name || name.length < 2)
        return name;
    if (name.length === 2) {
        return name[0] + '*';
    }
    return name[0] + '*'.repeat(name.length - 2) + name[name.length - 1];
}
function getBoxTypCdByFee(fee) {
    const map = {
        '2500': 'A',
        '3000': 'B',
        '4000': 'C',
        '5000': 'D',
    };
    return map[String(fee)] || 'A';
}
function maskPhone(phone) {
    if (!phone)
        return phone;
    const digits = phone.replace(/[^0-9]/g, '');
    if (digits.length < 4)
        return phone;
    const masked = digits.slice(0, -4) + '****';
    if (phone.includes('-')) {
        return masked.replace(/(\d{3})(\d{3,4})(\d{4})/, '$1-$2-****');
    }
    return masked;
}
function maskDetailAddress(address) {
    if (!address)
        return address;
    const idx = address.lastIndexOf(' ');
    if (idx === -1)
        return address;
    return address.slice(0, idx) + ' ****';
}
function sanitizeDeliveryMessage(message) {
    let sanitized = String(message || '');
    const blockedPhrases = [
        '택배 [총 운영자추가할인] 0.00',
        '상담처리: 출고',
        '택배, 등기, 소포 오늘출발'
    ];
    blockedPhrases.forEach((phrase) => {
        sanitized = sanitized.split(phrase).join(' ');
    });
    return sanitized
        .replace(/\r/g, '')
        .replace(/[ \t]+/g, ' ')
        .replace(/\s*\n\s*/g, '\n')
        .replace(/\n{2,}/g, '\n')
        .replace(/^[\s,|/:-]+|[\s,|/:-]+$/g, '')
        .trim();
}
const HanjinWaybill = ({ wblData, index }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s;
    const tmlBarcodeRef = useRef(null);
    const wblNumBarcodeRef = useRef(null);
    const eblNumBarcodeRef = useRef(null);
    const officeCode = wblData.office_code ||
        wblData.s_tml_cod ||
        wblData.tml_cod ||
        wblData.cen_cod ||
        '';
    const officeName = wblData.office_name ||
        wblData.s_tml_nam ||
        wblData.cen_nam ||
        wblData.es_nam ||
        '';
    const terminalCode = officeCode || '';
    const terminalName = officeName || '';
    const deliveryMessage = sanitizeDeliveryMessage(String(((_a = wblData.orderInfo) === null || _a === void 0 ? void 0 : _a.message) ||
        ((_b = wblData.orderData) === null || _b === void 0 ? void 0 : _b.message) ||
        ''));
    useEffect(() => {
        // 터미널 바코드 생성
        if (tmlBarcodeRef.current && terminalCode) {
            JsBarcode(tmlBarcodeRef.current, terminalCode, {
                format: 'CODE128',
                width: 1.2,
                height: 32,
                displayValue: false,
                margin: 0,
            });
        }
        // 운송장번호 바코드 생성
        if (wblNumBarcodeRef.current && wblData.wbl_num) {
            JsBarcode(wblNumBarcodeRef.current, wblData.wbl_num, {
                format: 'ITF',
                width: 1.6,
                height: 80,
                displayValue: false,
                margin: 0,
            });
        }
        if (eblNumBarcodeRef.current && wblData.wbl_num) {
            JsBarcode(eblNumBarcodeRef.current, wblData.wbl_num, {
                format: 'ITF',
                width: 3,
                height: 80,
                displayValue: false,
                margin: 0,
            });
        }
    }, [terminalCode, wblData.wbl_num]);
    return (_jsx("div", { className: "waybill-container hanjin-waybill", style: {
            width: '260mm',
            height: '120mm',
            margin: '0',
            padding: '0',
            fontFamily: "'HY헤드라인M', 'Malgun Gothic', 'Arial', sans-serif",
            background: '#fff',
            boxSizing: 'border-box',
            border: '1px solid #000',
            overflow: 'hidden',
            pageBreakAfter: 'always',
            pageBreakInside: 'avoid',
            breakInside: 'avoid',
            position: 'relative',
            display: 'block',
            minHeight: '120mm'
        }, children: _jsxs("div", { style: { display: 'flex', width: '260mm', height: '120mm' }, children: [_jsxs("div", { style: {
                        width: '130mm',
                        borderRight: '1px solid #000',
                        padding: 0,
                        boxSizing: 'border-box',
                        position: 'relative',
                        height: '120mm',
                        display: 'flex',
                        flexDirection: 'column'
                    }, children: [_jsxs("div", { style: {
                                display: 'flex',
                                padding: '0',
                                lineHeight: 1,
                            }, children: [_jsx("div", { style: {
                                        fontSize: 70,
                                        marginLeft: "4mm",
                                        marginRight: "2.5mm",
                                        fontWeight: 700,
                                        letterSpacing: 2,
                                        padding: 0,
                                        lineHeight: 1,
                                    }, children: wblData.hub_cod }), _jsx("div", { style: {
                                        fontSize: 70,
                                        fontWeight: 700,
                                        margin: 0,
                                        padding: 0,
                                        lineHeight: 1,
                                    }, children: wblData.tml_cod }), _jsx("div", { style: {
                                        fontSize: 70,
                                        fontWeight: 700,
                                        marginLeft: "4mm",
                                        marginRight: "2.5mm",
                                        padding: 0,
                                        lineHeight: 1,
                                    }, children: wblData.dom_mid }), _jsx("div", { style: {
                                        fontSize: 70,
                                        fontWeight: 700,
                                        marginLeft: "4mm",
                                        marginRight: "2.5mm",
                                        padding: 0,
                                        lineHeight: 1,
                                    }, children: wblData.es_cod })] }), _jsxs("div", { style: { display: 'flex', alignItems: 'center', marginLeft: '5mm' }, children: [_jsx("svg", { ref: tmlBarcodeRef, style: { width: '32mm', height: '10mm' }, "data-barcode-type": "tml", "data-code": terminalCode }), _jsxs("div", { style: { display: 'flex', flexDirection: 'column', marginLeft: 8, alignItems: 'center', minWidth: 32 }, children: [_jsx("span", { style: { fontSize: 18, fontWeight: 700 }, children: wblData.cen_cod }), _jsx("span", { style: { fontSize: 18, fontWeight: 700 }, children: wblData.cen_nam })] }), _jsxs("div", { style: { fontSize: 32, fontWeight: 700, marginLeft: 20 }, children: [wblData.grp_rnk, " ", wblData.es_nam] })] }), _jsxs("div", { style: { fontSize: 22, fontWeight: 500, marginLeft: '12mm' }, children: [(_c = wblData.productInfo) === null || _c === void 0 ? void 0 : _c.product_name, "-", (_d = wblData.orderInfo) === null || _d === void 0 ? void 0 : _d.quantity, "\uAC1C-", wblData.quantityIndex + 1, "/", (_e = wblData.orderInfo) === null || _e === void 0 ? void 0 : _e.quantity, " (", wblData.boxIndex, "/", ((_f = wblData.orderInfo) === null || _f === void 0 ? void 0 : _f.boxqty) || 1, ")"] }), _jsx("div", { style: { marginLeft: '4mm' }, children: _jsx("svg", { ref: eblNumBarcodeRef, style: { width: '100mm', height: '12mm' }, "data-barcode-type": "ebl", "data-code": wblData.wbl_num }) }), _jsx("div", { style: { marginLeft: '4mm' }, children: ((_g = wblData.locationInfo) === null || _g === void 0 ? void 0 : _g.locationSort) || '로케이션 정보 없음' }), _jsx("div", { style: {
                                marginLeft: '4mm',
                                marginRight: '4mm',
                                minHeight: '12mm',
                                fontSize: 14,
                                lineHeight: 1.25,
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-all'
                            }, children: deliveryMessage || '배송메세지 없음' }), _jsx("div", { style: { fontSize: 100, textAlign: 'center', fontWeight: 1000 }, children: "\uD55C\uC9C4" }), _jsx("div", { style: {
                                position: 'absolute',
                                left: '6mm',
                                bottom: '6mm',
                                fontSize: 22,
                                fontWeight: 700,
                                borderRadius: 4,
                                padding: '2px 12px'
                            }, children: wblData.dom_rgn === '7' ? '제주' : wblData.dom_rgn === '9' ? '도서' : '' })] }), _jsxs("div", { style: {
                        width: '130mm',
                        padding: 0,
                        boxSizing: 'border-box',
                        position: 'relative',
                        height: '120mm',
                        display: 'flex',
                        flexDirection: 'column'
                    }, children: [_jsx("div", { style: { fontSize: 22, fontWeight: 700, textAlign: 'left', marginLeft: '20mm' }, children: wblData.wbl_num }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row', marginLeft: '12mm', minHeight: 18 }, children: [_jsx("div", { style: { fontSize: 15, fontWeight: 500 }, children: (_h = wblData.orderInfo) === null || _h === void 0 ? void 0 : _h.recipient_name }), _jsx("div", { style: { fontSize: 15, marginLeft: '50mm', fontWeight: 500 }, children: (_j = wblData.orderInfo) === null || _j === void 0 ? void 0 : _j.mobile_phone })] }), _jsx("div", { style: { fontSize: 15, marginLeft: '12mm', fontWeight: 500, minHeight: 43 }, children: (_k = wblData.orderInfo) === null || _k === void 0 ? void 0 : _k.address }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row', marginLeft: '12mm', minHeight: 18 }, children: [_jsx("div", { style: { fontSize: 15, fontWeight: 500 }, children: "\uC8FC\uC2DD\uD68C\uC0AC\uC640\uC774\uB514" }), _jsx("div", { style: { fontSize: 15, marginLeft: '50mm', fontWeight: 500 }, children: "1644-2268" })] }), _jsx("div", { style: { fontSize: 15, marginLeft: '12mm', fontWeight: 500, minHeight: 22 }, children: "\uACBD\uAE30\uB3C4 \uAE40\uD3EC\uC2DC \uD558\uC131\uBA74 \uC11D\uD3C9\uB85C15\uBC88\uAE38 194" }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row', marginLeft: '8mm', marginTop: '1mm' }, children: [_jsx("div", { style: { fontSize: 32, fontWeight: 500 }, children: wblData.grp_rnk }), _jsx("div", { style: { fontSize: 32, marginLeft: '13mm', fontWeight: 500 }, children: wblData.es_nam }), _jsx("div", { style: { fontSize: 32, marginLeft: '5mm', fontWeight: 500 }, children: wblData.hub_cod }), _jsx("div", { style: { fontSize: 32, marginLeft: '1mm', fontWeight: 500 }, children: wblData.tml_cod }), _jsx("div", { style: { fontSize: 32, marginLeft: '4mm', fontWeight: 500 }, children: wblData.cen_cod })] }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row', marginLeft: '8mm' }, children: [_jsxs("div", { style: { display: 'flex', flexDirection: 'column' }, children: [_jsx("div", { style: { fontSize: 15 }, children: "\uC815\uC0C1" }), _jsx("div", { style: { fontSize: 15 }, children: (_l = wblData.orderInfo) === null || _l === void 0 ? void 0 : _l.order_date }), _jsxs("div", { style: { fontSize: 15 }, children: ["\uC218\uB7C9: ", wblData.quantityIndex, "/", (_m = wblData.orderInfo) === null || _m === void 0 ? void 0 : _m.quantity, " \uBC15\uC2A4: ", wblData.boxIndex, "/", ((_o = wblData.orderInfo) === null || _o === void 0 ? void 0 : _o.boxqty) || 1, " \uC6B4\uC784\uD0C0\uC785: ", wblData.boxType] }), _jsxs("div", { style: { fontSize: 15 }, children: ["\uCD9C\uACE0\uBC88\uD638 : ", (_p = wblData.orderInfo) === null || _p === void 0 ? void 0 : _p.order_number] })] }), _jsx("div", { style: { marginLeft: '4mm' }, children: _jsx("svg", { ref: wblNumBarcodeRef, style: { width: '100mm', height: '12mm' }, "data-barcode-type": "wbl", "data-code": wblData.wbl_num }) })] }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row', marginLeft: '8mm', height: 40, alignItems: 'flex-end', marginTop: '-3mm' }, children: [_jsx("div", { style: { fontSize: 15, fontWeight: 500 }, children: "\uD2B9\uC774\uC0AC\uD56D" }), _jsxs("div", { style: { display: 'flex', flexDirection: 'column', marginLeft: '50mm' }, children: [_jsx("div", { style: { fontSize: 15, fontWeight: 700, textAlign: 'left' }, children: wblData.wbl_num }), _jsxs("div", { style: { fontSize: 25, fontWeight: 500 }, children: ["\uBC1C\uC9C0: ", terminalCode, "   ", terminalName] })] })] }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row', marginLeft: '8mm', minHeight: 16, alignItems: 'flex-start', marginTop: '0mm' }, children: [_jsx("div", { style: { fontSize: 13, fontWeight: 500, width: '18mm', flexShrink: 0 }, children: "\uBC30\uC1A1\uBA54\uC138\uC9C0" }), _jsx("div", { style: {
                                        fontSize: 13,
                                        fontWeight: 500,
                                        lineHeight: 1.2,
                                        whiteSpace: 'pre-wrap',
                                        wordBreak: 'break-all',
                                        flex: 1,
                                        marginLeft: '4mm',
                                        paddingRight: '6mm'
                                    }, children: deliveryMessage || '배송메세지 없음' })] }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row', marginLeft: '12mm' }, children: [_jsx("div", { style: { fontSize: 15, fontWeight: 500 }, children: maskName(((_q = wblData.orderInfo) === null || _q === void 0 ? void 0 : _q.recipient_name) || '') }), _jsx("div", { style: { fontSize: 15, marginLeft: '50mm', fontWeight: 500 }, children: maskPhone(((_r = wblData.orderInfo) === null || _r === void 0 ? void 0 : _r.mobile_phone) || '') })] }), _jsx("div", { style: { fontSize: 15, marginLeft: '12mm', fontWeight: 500 }, children: maskDetailAddress(((_s = wblData.orderInfo) === null || _s === void 0 ? void 0 : _s.address) || '') }), _jsxs("div", { style: { display: 'flex', flexDirection: 'row', marginLeft: '12mm', marginTop: '1mm' }, children: [_jsx("div", { style: { fontSize: 15, fontWeight: 500 }, children: "\uC8FC\uC2DD\uD68C\uC0AC\uC640\uC774\uB514" }), _jsx("div", { style: { fontSize: 15, marginLeft: '50mm', fontWeight: 500 }, children: "1544-****" })] })] })] }) }));
};
export default HanjinWaybill;
